import useAnalytics from '~/libs/analytics/hooks/useAnalytics';

const useCircleciAnonymousId = (): string | null => {
  const analytics = useAnalytics();
  return analytics?.circleciAnonymousId ?? null;
};

export default useCircleciAnonymousId;
